import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button,
} from "reactstrap";

import ApiCaller from "../../api/apiCaller";
import NotiButton from "./NotiButton";

import "./index.css";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import actions from "actions";
import { useHistory } from "react-router-dom";
import ModalEnableTwoFactor from "./ModalEnableTwoFactor";
import { createErrorMessageSelector } from "reducers/selectors";
import ActionTypes from "actions/ActionTypes";
import LanguageButton from "./LanguageButton";
import t from "utils/Lang";

type NavigationBarProps = {
  toggleTwoFactor?: Function;
};

const NavigationBar = ({ toggleTwoFactor }: NavigationBarProps) => {
  const user = useSelector((state: any) => state.user.data);
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [hasUser, setHasUser] = useState(false);
  const [settingDropdown, setDropdown] = useState(false);
  const [modalTwoFactor, setModalTwoFactor] = useState(false);
  const [otpLink, setOtpLink] = useState("");
  const [showCopyUrlModal, setShowCopyUrlModal] = useState(false);
  const [copyUrlModalContent, setCopyUrlModalContent] = useState('');

  useEffect(() => {
    if (user) {
      setHasUser(true);
    }
  }, [user]);

  const logout = () => {
    //eslint-disable-next-line
    const r = confirm("Are you sure to log out?");
    if (r) {
      Cookies.remove("access_token");
      Cookies.remove("email");
      Cookies.remove("user_id");
      setHasUser(false);
      window.location.reload();
    }
  };

  if (
    window.location.href.includes("portal") ||
    window.location.href.includes("portal_success")
  ) {
    return null;
  }

  const toggle = () => {
    setDropdown((settingDropdown) => !settingDropdown);
  };
  const gotoResetPass = () => {
    history.push("/reset_password");
  };
  const handleTwoFactor = async () => {
    if (user.is_active_2fa) {
      disableTwoFactor();
    } else {
      enableTwoFactor();
    }
    toggleTwoFactor?.();
  };

  const disableTwoFactor = async () => {
    const res = await ApiCaller.delete("user/login2FA");
    alert(res.message);
  };

  const enableTwoFactor = async () => {
    const res = await ApiCaller.get("user/login2FA");
    const link = res?.result?.otp_link;
    if (link) {
      setOtpLink(link);
      setModalTwoFactor(true);
    } else {
      alert(res.message);
    }
  };

  const copyCurrentURL = async () => {
    const currentUrl = window.location.href;
    // if (navigator && navigator.clipboard) {
    //   await navigator.clipboard.writeText(currentUrl);
    // }
    setCopyUrlModalContent(`Current URL: ${currentUrl}`);
    toggleCopyUrlModal();
  };
  const toggleCopyUrlModal = () => {
    setShowCopyUrlModal(!showCopyUrlModal);
  };

  return (
    <div>
      <Navbar className="app-navigation-header" expand="md" color="white" dark>
        <NavbarBrand className="app-navigation-header-home-logo-text" href="/">
          <img
            src="/images/sc_logo.png"
            alt="Seedcom LISA"
            style={styles.logo}
          />
          <span className="app-navigation-header-brand-name">LISA</span>
        </NavbarBrand>
        <NavbarToggler
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          style={{ borderColor: "white" }}
        />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem style={styles.navItem}>
              <NavLink
                className="app-navigation-header-item-text"
                href="/sitev2"
              >
                {t().nav__site}
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                className="app-navigation-header-item-text"
                href="/store"
              >
                {t().nav__store}
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                className="app-navigation-header-item-text"
                href="/market_information"
              >
                {t().nav__market}
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                className="app-navigation-header-item-text"
                href="/planning/map"
              >
                {t().nav__map}
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink className="app-navigation-header-item-text" onClick={copyCurrentURL}>
                Copy URL
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink className="app-navigation-header-item-text" href="/help">
                {t().nav__support}
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink className="app-navigation-header-item-text" href="/finance/ifrs">
                IFRS COMPLIANCE
              </NavLink>
            </NavItem>
          </Nav>
          {!isOpen && (
            <Nav className="ml-auto" navbar>
              <NavItem>
                <div className="lisa-version-wrapper">
                  <span className="lisa-version-number">v3.1.2 {process.env.NODE_ENV}</span>
                </div>
              </NavItem>
              <NavItem>
                <div className="app-navigation-header-notification">
                  <NotiButton />
                </div>
              </NavItem>
              {user && (
                <Dropdown isOpen={settingDropdown} toggle={toggle}>
                  <DropdownToggle className="app-navigation-header-avatar">
                    <span>
                      {(user.first_name && user.first_name.charAt(0)) || "D"}
                      {user.last_name && user.last_name.charAt(0)}
                    </span>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem onClick={gotoResetPass}>
                      {t().home__change_password}
                    </DropdownItem>
                    <DropdownItem onClick={handleTwoFactor}>
                      {user.is_active_2fa
                        ? t().nav__off_two_factor
                        : t().nav__on_two_factor}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )}
              <NavItem>
                <LanguageButton />
              </NavItem>
              {hasUser && (
                <NavItem>
                  <NavLink
                    className="app-navigation-header-logout-button"
                    onClick={logout}
                  >
                    {t().nav__log_out}
                  </NavLink>
                </NavItem>
              )}
            </Nav>
          )}
        </Collapse>
      </Navbar>
      <ModalEnableTwoFactor
        isOpen={modalTwoFactor}
        link={otpLink}
        toggle={() => setModalTwoFactor((modalTwoFactor) => !modalTwoFactor)}
      />
      {showCopyUrlModal &&
        <Modal isOpen={showCopyUrlModal} toggle={toggleCopyUrlModal}>
          <ModalHeader toggle={toggleCopyUrlModal}>Current URL</ModalHeader>
          <ModalBody>
            {copyUrlModalContent}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleCopyUrlModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      }
    </div>
  );
};

const styles = {
  navItem: { marginLeft: 20 },
  logo: {
    width: 30,
    height: 32,
  },
};

export default NavigationBar;
